import React, { useState } from 'react';
import NusmaHeader from './components/NusmaHeader';
import NusmaHeroSection from './components/NusmaHeroSection';
import NusmaProductsSection from './components/NusmaProductsSection';
import NusmaServicesSection from './components/NusmaServicesSection';
import NusmaContactSection from './components/NusmaContactSection';
import NusmaDemoSection from './components/NusmaDemoSection';
import NusmaFooter from './components/NusmaFooter';

const App = () => {
  const [currentPage, setCurrentPage] = useState('inicio');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigate = (page) => {
    setCurrentPage(page);
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'inicio':
        return (
          <>
            <NusmaHeroSection 
              onNavigateToDemo={() => handleNavigate('demo')}
              onNavigateToProducts={() => handleNavigate('productos')}
            />
            <NusmaProductsSection 
              onNavigateToDemo={() => handleNavigate('demo')}
              onNavigateToContact={() => handleNavigate('contacto')}
            />
            <NusmaServicesSection 
              onNavigateToContact={() => handleNavigate('contacto')}
            />
          </>
        );
      case 'productos':
        return (
          <div className="pt-16">
            <NusmaProductsSection 
              onNavigateToDemo={() => handleNavigate('demo')}
              onNavigateToContact={() => handleNavigate('contacto')}
            />
          </div>
        );
      case 'servicios':
        return (
          <div className="pt-16">
            <NusmaServicesSection 
              onNavigateToContact={() => handleNavigate('contacto')}
            />
          </div>
        );
      case 'contacto':
        return (
          <div className="pt-16">
            <NusmaContactSection />
          </div>
        );
      case 'demo':
        return (
          <div className="pt-16">
            <NusmaDemoSection 
              onNavigateToContact={() => handleNavigate('contacto')}
            />
          </div>
        );
      default:
        return (
          <>
            <NusmaHeroSection 
              onNavigateToDemo={() => handleNavigate('demo')}
              onNavigateToProducts={() => handleNavigate('productos')}
            />
            <NusmaProductsSection 
              onNavigateToDemo={() => handleNavigate('demo')}
              onNavigateToContact={() => handleNavigate('contacto')}
            />
            <NusmaServicesSection 
              onNavigateToContact={() => handleNavigate('contacto')}
            />
          </>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-950">
      <NusmaHeader 
        currentPage={currentPage}
        onNavigate={handleNavigate}
        isMenuOpen={isMenuOpen}
        onToggleMenu={handleToggleMenu}
      />
      
      <main>
        {renderCurrentPage()}
      </main>
      
      <NusmaFooter 
        onNavigate={handleNavigate}
      />
    </div>
  );
};

export default App;